<div class="accordion expandable-information-box" [id]="'infoBox_' + id">
  <div class="card">
    <div class="card-header" [id]="'infoBox-header_' + id">
      <h2 class="mb-0">
        <button
          class="btn btn-link"
          type="button"
          data-toggle="collapse"
          [attr.data-target]="'#collapseContent_' + id"
          aria-expanded="false"
          [attr.aria-controls]="'collapseContent_' + id"
          [attr.yp-e2e-id]="'button_'+id"
        >
          <i class="fa fa-question-circle"></i>
          {{label}}
        </button>
      </h2>
    </div>

    <div
      [id]="'collapseContent_' + id"
      class="collapse"
      [attr.aria-labelledby]="'infoBox-header_' + id"
      [attr.data-parent]="'#infoBox_' + id"
    >
      <div class="card-body">
        <p [innerHTML]="content" [attr.yp-e2e-id]="'content_'+id"></p>
      </div>
    </div>
  </div>
</div>
